import {CREATE, GET_ALL_CLUBS, GET_ONE, UPDATE_LICENCE_CLUB} from '../actions/club'

const initialState = {
    club: {}
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
    switch (action.type) {
        case CREATE:
            return state
        case GET_ALL_CLUBS:
            return state
        case UPDATE_LICENCE_CLUB:
            return state
        case GET_ONE:
            return action.payload
        default:
            return state
    }
}
